import * as Sentry from '@sentry/gatsby'

import { GIT_HASH, RELEASE_ENV, SENTRY_DSN, DISABLE_SENTRY } from './src/config'

if (RELEASE_ENV && RELEASE_ENV !== 'development' && !DISABLE_SENTRY) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: RELEASE_ENV,
    integrations: [
      // Filter out errors from third-party sources.
      // See https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['sentry-farewill-com-app-key'],
        // Defines how to handle errors that contain third party stack frames.
        // Possible values are:
        // - 'drop-error-if-contains-third-party-frames'
        // - 'drop-error-if-exclusively-contains-third-party-frames'
        // - 'apply-tag-if-contains-third-party-frames'
        // - 'apply-tag-if-exclusively-contains-third-party-frames'
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
    release: GIT_HASH,
    sampleRate: 1,
  })
}
